import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`The authors would like to thank Nicholas Reese, the OECD.AI working group on
the classification of AI, the OECD Secretariat Directorate for Science,
Technology, and Innovation, specifically Karine Perset, Louise Hatem, and Luis
Aranda, as well as Eish Sumra, Rebecca Gelles, Alex Friedland, Lynne Weil,
Dewey Murdick, and Igor Mikolic-Torreira for their
guidance and assistance over the course of this research. Thanks as well to
those who provided invaluable feedback and editorial support for the full
report.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      